import { StringMapping, ValueMapping } from "@opendaw/lib-std";
import { Devices } from "../../DeviceAdapter";
import { ParameterAdapterSet } from "../../ParameterAdapterSet";
import { TrackType } from "../../timeline/TrackType";
export class NanoDeviceBoxAdapter {
    type = "instrument";
    accepts = "midi";
    #context;
    #box;
    #parametric;
    namedParameter; // let typescript infer the type
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
        this.#parametric = new ParameterAdapterSet(this.#context);
        this.namedParameter = this.#wrapParameters(box);
    }
    get box() { return this.#box; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get labelField() { return this.#box.label; }
    get iconField() { return this.#box.icon; }
    get defaultTrackType() { return TrackType.Notes; }
    get enabledField() { return this.#box.enabled; }
    get minimizedField() { return this.#box.minimized; }
    get acceptsMidiEvents() { return true; }
    deviceHost() {
        return this.#context.boxAdapters
            .adapterFor(this.#box.host.targetVertex.unwrap("no device-host").box, Devices.isHost);
    }
    audioUnitBoxAdapter() { return this.deviceHost().audioUnitBoxAdapter(); }
    terminate() { this.#parametric.terminate(); }
    #wrapParameters(box) {
        return {
            volume: this.#parametric.createParameter(box.volume, ValueMapping.DefaultDecibel, StringMapping.numeric({ unit: "db", fractionDigits: 1 }), "volume"),
            release: this.#parametric.createParameter(box.release, ValueMapping.exponential(0.001, 8.0), StringMapping.numeric({ unit: "s", fractionDigits: 3 }), "release")
        };
    }
}
